import { Layout } from "layout"
import { Outlet } from "react-router"

const OperatorPanel = () => (
  <Layout hasSideBar={false}>
    <Outlet />
  </Layout>
)

export default OperatorPanel
